import { render, staticRenderFns } from "./discovery-wall.vue?vue&type=template&id=651c30da&"
import script from "./discovery-wall.vue?vue&type=script&lang=ts&"
export * from "./discovery-wall.vue?vue&type=script&lang=ts&"
import style0 from "./discovery-wall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports